import { createRouter, createWebHistory } from "vue-router"
import HomeView from "../views/HomeView.vue"
import CategoryView from "../views/CategoryView.vue"
import AboutView from "../views/AboutView.vue"
import AdminView from "../views/AdminView.vue"

const routes = [
  { path: "/", component: HomeView },
  { path: "/category/:id", component: CategoryView },
  { path: "/about", component: AboutView },
  { path: "/admin", component: AdminView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
